/**
 * window.Cypress appears to be unreliabley set, everywhere we currently check for Cypress, we have the user email so we can also regex match the email to not send
 */
export function isCypressUserEmail(email: string | undefined | null) {
  if (window.Cypress) return true;
  return !!email?.match(/cypress\+[\w.-]+@apollographql\.com/);
}
